import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const faqs = [{
    question: 'Is sub-leasing legal?',
    answer: "Yes. The Shadow Clause is a legal addendum that creates a transparent, mutually beneficial agreement with the property owner. You're not hiding anything — you're providing a premium service that increases the landlord's occupancy rate and reduces their vacancy risk. The blueprint includes the exact legal language reviewed by real estate attorneys in FL and TX."
  }, {
    question: "I'm not tech-savvy. Can I still do this?",
    answer: 'If you can use email and a smartphone, you can run this. The 3-App Autopilot section walks you through setup in under 45 minutes. One app handles bookings, one handles guest communication, and one handles pricing. Average weekly time commitment: 2 hours.'
  }, {
    question: 'What if the landlord cancels my lease?',
    answer: "The Shadow Clause protects you. It creates a corporate housing addendum that benefits the landlord financially. In 3 years of operation, we've had a 97% landlord renewal rate. They make more money with you than without you."
  }, {
    question: "This sounds too good to be true. What's the catch?",
    answer: "The catch is that it requires upfront work: finding the right unit, furnishing it, and setting up systems. It's not passive income on day one — it's a real business that becomes semi-passive after month 2. The $1,100/mo profit is a conservative average, not a best-case scenario."
  }, {
    question: "I don't have $15,000. Can I start with less?",
    answer: "Yes. Your first unit requires roughly $3,500 for furniture and $3,000 for first/last month rent — about $6,500 total. The blueprint includes a 'Low-Capital Start' guide for those starting with under $10k."
  }, {
    question: 'Why is this only $6.36? The regular price says $47.',
    answer: "We're running a limited launch promotion at 86% off. The regular price is $47, and it will return to that once this window closes. There's no upsell, no mastermind pitch, no coaching program behind this. The blueprint is the product. At $6.36, there's literally no reason not to grab it — that's less than a coffee and a sandwich."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0f1724] py-12 md:py-20 px-4 relative" data-id="element-123">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-124"></div>

      <div className="max-w-3xl mx-auto" data-id="element-125">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-2xl md:text-4xl text-[#c9a84c] text-center mb-8 md:mb-12" data-id="element-126">
          Straight Answers to Hard Questions
        </motion.h2>

        <div className="space-y-4" data-id="element-127">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="border-b border-[#c9a84c]/10 last:border-0" data-id="element-128">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-4 md:py-6 flex justify-between items-center text-left focus:outline-none group gap-3" data-id="element-129">
                <span className="text-base md:text-xl font-bold text-white group-hover:text-[#c9a84c] transition-colors" data-id="element-130">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-[#c9a84c] flex-shrink-0 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-131" />
              </button>
              <AnimatePresence data-id="element-132">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-133">
                    <p className="pb-4 md:pb-6 text-[#f5f0e8]/80 text-base md:text-lg leading-relaxed" data-id="element-134">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}